import React, { useState } from "react";
import { MapPinOff, Send, Loader2, Check } from "lucide-react";
import api from "../api";
import { useLang } from "../context/LanguageContext";
import { useToast } from "../hooks/use-toast";

// An empty map is honest information, not a dead end: say so, then turn the visit into a lead.
export const NoDealsHere = ({ place = "", country = "", lat, lng }) => {
  const { t } = useLang();
  const { toast } = useToast();
  const [town, setTown] = useState(place);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/demand", { place: town, country, lat, lng, email: email.trim() || undefined });
      setDone(true);
      toast({ title: t("nd.thanks"), description: t("nd.thanksNote", { place: town || country }) });
    } catch (err) {
      const d = err.response?.data?.detail;
      toast({ title: typeof d === "string" ? d : t("acc.pleaseTryAgain") });
    } finally { setBusy(false); }
  };

  if (done) {
    return (
      <div className="border border-[#16a34a]/40 bg-[#e7f6ec] dark:bg-[#16341f] rounded-xl p-4" data-testid="no-deals-done">
        <p className="text-sm font-bold text-foreground flex items-center gap-1.5">
          <Check size={15} className="text-[#16a34a]" /> {t("nd.onTheList")}
        </p>
        <p className="text-xs text-muted-foreground mt-1">{t("nd.onTheListNote")}</p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="border border-border rounded-xl p-4 bg-card" data-testid="no-deals-here">
      <p className="text-sm font-bold text-foreground flex items-center gap-1.5">
        <MapPinOff size={15} className="text-[#16a34a]" /> {t("nd.title")}
      </p>
      <p className="text-xs text-muted-foreground mt-1">{t("nd.sub")}</p>
      <input value={town} onChange={(e) => setTown(e.target.value)} data-testid="demand-town-input"
        placeholder={t("nd.townPlaceholder")} maxLength={80}
        className="mt-3 w-full bg-secondary rounded-xl px-3 py-2.5 text-sm font-semibold text-foreground outline-none focus:ring-2 ring-[#16a34a]/40" />
      <input value={email} onChange={(e) => setEmail(e.target.value)} data-testid="demand-email-input"
        type="email" placeholder={t("nd.emailPlaceholder")}
        className="mt-2 w-full bg-secondary rounded-xl px-3 py-2.5 text-sm font-semibold text-foreground outline-none focus:ring-2 ring-[#16a34a]/40" />
      <button type="submit" disabled={busy || (!town.trim() && !country)} data-testid="demand-submit-btn"
        className="mt-3 w-full inline-flex items-center justify-center gap-1.5 bg-[#16a34a] hover:bg-[#15803d] disabled:opacity-60 text-white text-sm font-bold rounded-xl px-4 py-2.5 transition-colors">
        {busy ? <Loader2 className="animate-spin" size={15} /> : <Send size={15} />} {t("nd.cta")}
      </button>
    </form>
  );
};

export default NoDealsHere;
